import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { useFormik } from "formik"
import * as Yup from "yup"
import i18n from "i18n"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
} from "@mui/material"

const SingleTextInputModal = ({
  open = false,
  setOpen,
  title = "",
  subtitle = "",
  btnSubmitLabel = i18n.t("buttons.save"),
  btnCancelLabel = i18n.t("buttons.cancel"),
  fnSubmit = () => {},
  fnCancel = () => {},
  initialValue = "",
}) => {
  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    initialValues: {
      value: initialValue,
    },
    validationSchema: Yup.object({
      value: Yup.string().trim().required(i18n.t("validation.required")),
    }),
    onSubmit: values => {
      fnSubmit(values.value)
      setOpen(false)
    },
  })

  useEffect(() => {
    if (!open) formik.resetForm()
  }, [open])

  const handleCancel = () => {
    fnCancel()
    setOpen(false)
  }

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="sm" fullWidth>
      {title && <DialogTitle>{title}</DialogTitle>}
      <form onSubmit={formik.handleSubmit}>
        <DialogContent>
          {subtitle && (
            <Typography variant="subtitle1" gutterBottom>
              {subtitle}
            </Typography>
          )}
          <TextField
            fullWidth
            name="value"
            value={formik.values.value}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            margin="normal"
            autoFocus
            error={formik.touched.value && Boolean(formik.errors.value)}
            helperText={formik.touched.value && formik.errors.value}
          />
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 2,
            marginBottom: 2,
          }}
        >
          <Button onClick={handleCancel} color="secondary" variant="outlined">
            {btnCancelLabel}
          </Button>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            disabled={!formik.isValid || !formik.dirty}
          >
            {btnSubmitLabel}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

SingleTextInputModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  btnSubmitLabel: PropTypes.string,
  btnCancelLabel: PropTypes.string,
  fnSubmit: PropTypes.func,
  fnCancel: PropTypes.func,
  initialValue: PropTypes.string,
}

export default SingleTextInputModal
